import {HTTP} from '../http-common';

let Admins = []

HTTP.get('users/admin')
.then(response => {
  let i;
  for (i=0; i<response.data.data.length;i++) {
    let id = response.data.data[i]._id;
    let email = response.data.data[i].email;
    let name = response.data.data[i].nama;
    let phone = response.data.data[i].telepon;
  
    Admins.push({"id": id, "email": email, "name": name, "phone": phone})
  }
})  

const getAdminById = (id) => {
  return (id === undefined) ? Admins[0] : Admins.find(x => x.id === id);
};

const getAdmin = (limit) => {
  return (limit) ? Admins.slice(0, limit) : Admins;
};

export {
  Admins,
  getAdmin,
  getAdminById
};